var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import ReactDOM from 'react-dom';
import Anchor from '@telia-front/anchor';
import Container from '@telia-front/container';
import Icon from '@telia-front/icon';
import HeaderDropdown from '../header-dropdown/header-dropdown';
import HeaderSegment from '../header-segment/header-segment';
const HeaderEmployee = (props) => {
    const { environment = 'live', segment, actions, openSection, openAnimatingSection, dropdownContainer, onDropdownClose, onActionClick, onDropdownTransitionExited, } = props;
    const BEM = () => {
        const classArray = ['header__employee', `header__employee--${environment}`];
        return classArray.join(' ');
    };
    const getSegmentColor = () => {
        switch (environment) {
            case 'test':
                return 'employee-test';
            case 'dev':
                return 'employee-dev';
            case 'live':
            default:
                return 'employee';
        }
    };
    return (React.createElement("div", { className: BEM() },
        React.createElement(Container, null,
            React.createElement("div", { className: "header__top-inner" },
                React.createElement("div", { className: "header__top-left" }, segment && React.createElement(HeaderSegment, Object.assign({}, segment, { color: getSegmentColor() }))),
                React.createElement("div", { className: "header__top-right" },
                    React.createElement(HeaderEmployeeActions, { items: actions.items, currentSection: openSection, currentAnimatingSection: openAnimatingSection, dropdownContainer: dropdownContainer, onDropdownClose: onDropdownClose, onActionClick: onActionClick, onDropdownTransitionExited: onDropdownTransitionExited }))))));
};
export default HeaderEmployee;
const HeaderEmployeeActions = React.memo((props) => {
    const { currentSection, currentAnimatingSection, dropdownContainer, items, onActionClick, onDropdownClose, onDropdownTransitionExited } = props;
    return (React.createElement("ul", { className: "header__employee-actions" }, items.map(item => {
        const handleActionClick = (event) => {
            event.preventDefault();
            onActionClick(item.id, event);
            if (item.onClick) {
                item.onClick(event);
            }
        };
        return (React.createElement(HeaderEmployeeActionsItem, Object.assign({}, item, { dropdownContainer: dropdownContainer, isCurrent: currentSection === item.id, isCurrentAnimating: currentAnimatingSection === item.id, onDropdownClose: onDropdownClose, onDropdownTransitionExited: onDropdownTransitionExited, onClick: item.dropdownContent ? handleActionClick : item.onClick, key: item.id })));
    })));
});
const HeaderEmployeeActionsItem = React.memo((props) => {
    const { dropdownContainer, dropdownContent, dropdownSize = 'small', dropdownPadding, hideLabel = false, icon, isCurrent = false, isCurrentAnimating = false, isDropdownPadded = false, label, labelClassName, onDropdownClose, onDropdownTransitionExited, showArrow } = props, rest = __rest(props, ["dropdownContainer", "dropdownContent", "dropdownSize", "dropdownPadding", "hideLabel", "icon", "isCurrent", "isCurrentAnimating", "isDropdownPadded", "label", "labelClassName", "onDropdownClose", "onDropdownTransitionExited", "showArrow"]);
    const anchorElement = React.useRef(null);
    const labelBEM = () => {
        const classArray = ['header__employee-item-label'];
        if (labelClassName) {
            classArray.push(labelClassName);
        }
        return classArray.join(' ');
    };
    const buttonBEM = () => {
        const classArray = ['header__employee-button'];
        if (hideLabel) {
            classArray.push('header__employee-button--hide-label');
        }
        if (icon) {
            classArray.push('header__employee-button--with-icon');
        }
        if (isCurrentAnimating) {
            classArray.push('is-current');
        }
        return classArray.join(' ');
    };
    return (React.createElement("li", { className: "header__employee-item" },
        React.createElement(Anchor, Object.assign({ isUnderlined: false }, rest, { className: buttonBEM(), elementRef: anchorElement }),
            icon && React.createElement(Icon, { modifiers: icon, className: "header__employee-icon" }),
            React.createElement("span", { className: labelBEM() }, label),
            showArrow && React.createElement(Icon, { modifiers: "#arrow-down", className: "header__employee-arrow-icon" })),
        dropdownContainer &&
            ReactDOM.createPortal(React.createElement(HeaderDropdown, { offsetY: 0, size: dropdownSize, padded: isDropdownPadded, padding: dropdownPadding, onClose: onDropdownClose, reference: anchorElement.current, container: dropdownContainer, isShown: isCurrent, onTransitionExited: onDropdownTransitionExited }, dropdownContent), dropdownContainer)));
});
